import React from "react";
import { history } from "../../helpers/utils";
import { WORDINGS } from "../../helpers/constants";
import arrowLeft from "../../assets/Icons/chevron-left.svg";
import styles from "./index.module.css";

function Header({ details }) {
  return (
    <div className={styles["Request-Header"]}>
      <header>
        {details && (
          <img
            src={arrowLeft}
            alt="back"
            className={styles["request-header__back"]}
            onClick={() => history.push("/myRequests")}
          />
        )}
        {WORDINGS.MY_REQUESTS}
      </header>
    </div>
  );
}

export default Header;
